/**
 * Cuándo se ofrece el modo «todas las del filtro» (feature 025, US8).
 *
 * El backend recorre el filtro entero (fechas, supervisor, agentes) e ignora el texto del buscador
 * de la tabla, que filtra sólo en pantalla. Para que el resumen nunca sea de algo distinto de lo que
 * se ve, el modo no se ofrece mientras el buscador tenga texto (revisión del PR, pregunta 1).
 */
export function hasSearchText(filteringText) {
  return Boolean(filteringText && filteringText.trim());
}

export function isAllFilteredAvailable({ hasDateRange, itemsCount, allFiltered, filteringText }) {
  return Boolean(hasDateRange) && itemsCount > 0 && !allFiltered && !hasSearchText(filteringText);
}
